<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div
  *ngIf="isFormCollapsed"
  class="pop-up-container">
  <render-wysiwyg
    class="pop-up-text"
    [html]="settings?.general?.popUpCollapse?.text"
    [country]="country"
    [lang]="lang"
    [piece]="piece">
  </render-wysiwyg>
  <button
    type="submit"
    (click)="showNewsletter()"
    (keydown.enter)="showNewsletter()"
    class="pop-up-button">
    <render-wysiwyg
      [html]="settings?.general?.popUpCollapse?.buttonText"
      [country]="country"
      [lang]="lang"
      [piece]="piece">
    </render-wysiwyg>
  </button>
</div>

<ng-container *ngIf="isMobile; else showNewsletterTemplate">
    <render-modal-panel
      *ngIf="!isFormCollapsed"
      aria-labelledby="newsletter-modal"
      [hasToShowCloseButton]="true"
      #newsletterModal="render-modal-panel"
      [modalName]="'newsletter-modal-' + piece?.id">
        <div
          *ngIf="newsletterModal.open"
          class="newsletter-modal">
          <ng-template *ngTemplateOutlet="showNewsletterTemplate"></ng-template>
        </div>
    </render-modal-panel>
</ng-container>

<ng-template #showNewsletterTemplate>
  <idt-common-styles-render
    *ngIf="piece"
    [@collapseAnimation]="isFormCollapsed ? 'collapsed' : 'expanded'"
    class="collapse-content"
    [styles]="settings?.styles">
    <div *ngIf="hasToShowTitle || hasToShowSubtitle">
      <render-wysiwyg
        *ngIf="hasToShowTitle"
        [class.error-message]="!!subscriptionErrorMessage"
        [ngStyle]="titlePadding"
        [html]="titleContent"
        [country]="country"
        [lang]="lang"
        [piece]="piece">
      </render-wysiwyg>
      <render-wysiwyg
        *ngIf="hasToShowSubtitle"
        [html]="subtitleContent"
        [ngStyle]="subtitlePadding"
        [country]="country"
        [lang]="lang"
        [piece]="piece">
      </render-wysiwyg>
    </div>
    <form
      *ngIf="hasToShowForm"
      [formGroup]="form"
      (ngSubmit)="onSubmit()">

      <ng-container *ngIf="showUnsuscribeForm; then unsuscribeForm; else suscribeForm"></ng-container>

      <ng-template #unsuscribeForm>
        <ng-container *ngIf="!unsubscribeMessage; else unsubscribeMessageTpl">
          <ng-template *ngTemplateOutlet="inputContainer">
          </ng-template>

          <button
            type="submit"
            class="block">
            <render-wysiwyg
              [html]="settings?.general?.links?.unsubscribe?.text"
              [country]="country"
              [lang]="lang"
              [piece]="piece">
            </render-wysiwyg>
          </button>

          <div
            *ngIf="hasLinks"
            class="links"
            role="group">
            <a
              *ngIf="showUnsuscribeForm && settings.general.links?.unsubscribeToggle && settings.general.links?.unsubscribe?.backText"
              (click)="showUnsuscribeForm = false"
              role="button"
              tabindex="0"
              [attr.aria-label]="settings.general.links?.unsubscribe?.backText ?? 'Volver'"
              (keydown.enter)="showUnsuscribeForm = false">
              {{ settings.general.links?.unsubscribe?.backText ?? '' }}
            </a>
          </div>
        </ng-container>
      </ng-template>

      <ng-template #suscribeForm>
        <ng-template *ngTemplateOutlet="inputContainer">
        </ng-template>
          <div
            *ngIf="linkedCategories.length > 0"
            class="categories">
            <div
              *ngIf="settings?.general?.categories?.displayCategoriesTitleToggle"
              [ngStyle]="getPaddingStyles('titleText', true, settings?.general?.categories)"
              class="wysiwyg">
              <render-wysiwyg
                [html]="getTextByDevice(settings?.general?.categories, 'titleText')"
                [country]="country"
                [lang]="lang"
                [piece]="piece">
              </render-wysiwyg>
            </div>
            <div class="linked-categories">
              <div *ngFor="let linkedCategory of linkedCategories; let i = index; trackBy: trackByIndex">
                <label
                  class="checkbox-container"
                  [htmlFor]="'category_' + i"
                  >
                  <input
                    *ngIf="form.controls.linkedCategories.at(i) as checkbox"
                    type="checkbox"
                    [name]="'category_' + i"
                    [formControl]="checkbox">
                  <render-wysiwyg
                    [html]="linkedCategory.title"
                    [country]="country"
                    [lang]="lang"
                    [piece]="piece">
                  </render-wysiwyg>
                </label>
              </div>
            </div>
            <div
              *ngIf="hasRequiredCategoriesError"
              class="error-message">
              {{ requiredCategoriesMessage }}
            </div>
          </div>
          <div
            *ngIf="fieldsBirthdate && fieldsBirthdate?.formatBirthdate"
            class="birthdate-text">
            <div
              *ngIf="settings?.general?.birthdate?.titleText"
              [ngStyle]="getPaddingStyles('titleText', true, settings?.general?.birthdate)"
              class="wysiwyg">
              <render-wysiwyg
                [html]="getTextByDevice(settings?.general?.birthdate, 'titleText')"
                [country]="country"
                [lang]="lang"
                [piece]="piece">
              </render-wysiwyg>
            </div>
          </div>
          <div
            *ngIf="fieldsBirthdate && fieldsBirthdate?.formatBirthdate"
            class="birthdate-container"
            formGroupName="birthdate"
            role="group">
            <div
              class="birthdate-status">
              <div
                class="birthdate-wrapper">
                <label
                  for="birth-day"
                  class="visually-hidden">
                  {{ fieldsBirthdate.dayPlaceholder || 'Dia' }}
                </label>
                <input
                  id="birth-day"
                  name="day"
                  type="number"
                  maxLength="2"
                  min="1"
                  max="31"
                  formControlName="day"
                  [ngStyle]="inputStyle"
                  class="input-custom-style"
                  [attr.aria-invalid]="isFormSubmitted && form.controls.birthdate!.controls.day?.invalid"
                  [attr.aria-describedby]="isFormSubmitted && form.controls.birthdate!.controls.day?.invalid ? 'day-error' : null"
                  [placeholder]="fieldsBirthdate.dayPlaceholder ?? ''">
                  <ng-container *ngIf="form.controls.birthdate!.controls.day?.value">
                    <ng-container *ngTemplateOutlet="iconClose; context: {formReset: form.controls.birthdate!.controls.day, label: 'Reiniciar el dia'}"></ng-container>
                  </ng-container>
              </div>
              <span
                *ngIf="isFormSubmitted && form.controls.birthdate!.controls.day?.invalid"
                class="error-message"
                id="day-error"
                role="alert">
                {{ messageMandatoryBirthdate }}
              </span>
            </div>
            <div class="birthdate-status">
              <div
                class="birthdate-wrapper">
                <label
                  for="birth-month"
                  class="visually-hidden">
                  {{ fieldsBirthdate.monthPlaceholder || 'Mes' }}
                </label>
                <input
                  id="birth-month"
                  name="month"
                  type="number"
                  maxLength="2"
                  min="1"
                  max="12"
                  formControlName="month"
                  [ngStyle]="inputStyle"
                  class="input-custom-style"
                  [attr.aria-invalid]="isFormSubmitted && form.controls.birthdate!.controls.month?.invalid"
                  [attr.aria-describedby]="isFormSubmitted && form.controls.birthdate!.controls.month?.invalid ? 'month-error' : null"
                  [placeholder]="fieldsBirthdate.monthPlaceholder ?? ''">
                  <ng-container *ngIf="form.controls.birthdate!.controls.month?.value">
                    <ng-container *ngTemplateOutlet="iconClose; context: {formReset: form.controls.birthdate!.controls.month, label: 'Reiniciar el mes'}"></ng-container>
                  </ng-container>
              </div>
              <span
                *ngIf="isFormSubmitted && form.controls.birthdate!.controls.month?.invalid"
                class="error-message"
                id="month-error"
                role="alert">
                {{ messageMandatoryBirthdate }}
              </span>
            </div>
            <div
              *ngIf="fieldsBirthdate.formatBirthdate === 'dayMonthYear'"
              class="birthdate-status">
              <div
                class="birthdate-wrapper">
                <label
                  for="birth-year"
                  class="visually-hidden">
                  {{ fieldsBirthdate.yearPlaceholder || 'Año' }}
                </label>
                <input
                  id="birth-year"
                  name="year"
                  type="number"
                  maxLength="4"
                  min="1900"
                  max="9999"
                  formControlName="year"
                  [ngStyle]="inputStyle"
                  class="input-custom-style"
                  [attr.aria-invalid]="isFormSubmitted && form.controls.birthdate!.controls.year?.invalid"
                  [attr.aria-describedby]="isFormSubmitted && form.controls.birthdate!.controls.year?.invalid ? 'year-error' : null"
                  [placeholder]="fieldsBirthdate.yearPlaceholder ?? ''">
                  <ng-container *ngIf="form.controls.birthdate!.controls.year?.value">
                    <ng-container *ngTemplateOutlet="iconClose; context: {formReset: form.controls.birthdate!.controls.year, label: 'Reiniciar el año'}"></ng-container>
                  </ng-container>
              </div>
              <span
                *ngIf="isFormSubmitted && form.controls.birthdate!.controls.year?.invalid"
                class="error-message"
                id="year-error"
                role="alert">
                {{ messageMandatoryBirthdate }}
              </span>
            </div>
          </div>
          <div
            class="agree-text"
            [ngStyle]="getPaddingStyles('text')">
            <input
              required
              id="newsletter-agree"
              name="agree"
              type="checkbox"
              formControlName="agree"
              [attr.aria-invalid]="legalConditionsInvalid"
              [attr.aria-describedby]="legalConditionsInvalid ? 'legal-error-message' : null">
              <label
                for="newsletter-agree"
                class="wysiwyg">
                <render-wysiwyg
                  *ngIf="settings?.general?.text"
                  [html]="settings?.general?.text"
                  [country]="country"
                  [lang]="lang"
                  [piece]="piece">
                </render-wysiwyg>
              </label>
          </div>
          <div
            *ngIf="legalConditionsInvalid"
            class="legal-conditions-error"
            id="legal-error-message"
            role="alert"
            aria-live="assertive">
            <span class="error-message">{{settings?.general?.legalErrorMessage}}</span>
          </div>
        <ng-container
          *ngIf="isBlockButton; then submitButton;">
        </ng-container>
        <div
          *ngIf="hasLinks"
          class="links"
          role="group">
          <a
            *ngIf="settings.general.links?.unsubscribeToggle"
            (click)="showUnsuscribeForm = true"
            role="button"
            tabindex="0"
            [attr.aria-label]="settings.general.links?.unsubscribe?.text ?? 'Quiero darme de baja'"
            (keydown.enter)="showUnsuscribeForm = true">
            {{ settings.general.links?.unsubscribe?.text ?? '' }}
          </a>
          <a
            *ngIf="settings.general.links?.legalConditionsToggle"
            target="_blank"
            rel="noopener noreferrer"
            [href]="settings.general.links?.legalConditions?.url ?? ''"
            [attr.aria-label]="(settings.general.links?.legalConditions?.text ?? 'Leer la política de privacidad')">
            {{ settings.general.links?.legalConditions?.text ?? '' }}
          </a>
        </div>
      </ng-template>

      <ng-template #inputContainer>
        <div
          class="input-container"
          [ngStyle]="containerStyle">
          <div
            class="email-wrapper-newsletter email-wrapper-newsletter-block"
            [ngClass]="{'email-wrapper-newsletter-error': emailInvalid, 'email-wrapper-newsletter-inline': !isBlockButton}">
            <label
              for="newsletter-email"
              class="visually-hidden">
              Email
            </label>
            <input
              id="newsletter-email"
              autocomplete="email"
              name="email"
              type="email"
              formControlName="email"
              [ngStyle]="inputStyle"
              class="input-custom-style"
              [attr.aria-invalid]="emailInvalid"
              [attr.aria-describedby]="emailInvalid ? 'email-error-message' : null"
              [placeholder]="settings?.general?.placeholder ?? ''"
              (input)="resetFormSubmitted()">
            <ng-container *ngIf="form.controls.email?.value && !isLoading">
              <ng-container *ngTemplateOutlet="iconClose; context: {formReset: form.controls.email, label: 'Reiniciar el email'}"></ng-container>
            </ng-container>
            <ng-container *ngIf="isLoading; then loadingIcon"></ng-container>
          </div>
          <ng-container
            *ngIf="!isBlockButton && !showUnsuscribeForm; then submitButton;">
          </ng-container>
        </div>
        <div
          *ngIf="settings.general.showCustomEmailErrorToggle && emailInvalid"
          class="error-message email-error"
          id="email-error-message"
          role="alert"
          aria-live="assertive">
          {{settings.general.customEmailError}}
        </div>
      </ng-template>

      <ng-template #submitButton>
        <button
          type="submit"
          [class.block]="isBlockButton"
          attr.aria-label="Suscribirse a la newsletter">
          <ng-container *ngIf="buttonType === 'icon'; then iconButton; else textButton">
          </ng-container>
        </button>
      </ng-template>

      <ng-template #iconButton>
        <img
          *ngIf="hasCustomIconButton; else defaultIconButton"
          alt="Enviar"
          class="custom-icon"
          [src]="getCustomIcon(settings!.general.customIconButton!.image!)"/>
      </ng-template>

      <ng-template #defaultIconButton>
        <svg
          viewBox="0 0 16 16"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          focusable="false">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.072 8.024L5.715 3.667l.618-.62L11 7.716v.618L6.333 13l-.618-.619 4.357-4.357z"/>
        </svg>
      </ng-template>

      <ng-template #textButton>
        <render-wysiwyg
          [html]="getTextByDevice(settings?.general?.buttonSubmitStyles, 'text')"
          [country]="country"
          [lang]="lang"
          [piece]="piece">
        </render-wysiwyg>
      </ng-template>

      <ng-template #unsubscribeMessageTpl>
        <render-wysiwyg
          [ngStyle]="getPaddingStyles('padding', false, settings.general.links?.unsubscribe)"
          [html]="unsubscribeMessage"
          [country]="country"
          [lang]="lang"
          [piece]="piece">
        </render-wysiwyg>
      </ng-template>

      <ng-template
        #iconClose
        let-formReset="formReset"
        let-label="label">
        <button
          type="button"
          class="reset"
          [attr.aria-label]="label || 'Reiniciar el input'"
          (click)="formReset.reset()">
          <svg
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false">
            <path
            d="M0.898371 1.01361C1.24203 0.669944 1.79922 0.669944 2.14288 1.01361L13.8406 12.7114L25.5384 1.01361C25.882 0.669944 26.4392 0.669944 26.7829 1.01361C27.1265 1.35727 27.1265 1.91445 26.7829 2.25811L15.0851 13.9559L26.7829 25.6536C27.1265 25.9973 27.1265 26.5545 26.7829 26.8981C26.4392 27.2418 25.882 27.2418 25.5384 26.8981L13.8406 15.2004L2.14288 26.8981C1.79922 27.2418 1.24203 27.2418 0.898371 26.8981C0.55471 26.5545 0.55471 25.9973 0.898371 25.6536L12.5961 13.9559L0.898371 2.25811C0.55471 1.91445 0.55471 1.35727 0.898371 1.01361Z"/>
          </svg>
        </button>
      </ng-template>

      <ng-template #loadingIcon>
        <svg
          x="0px"
          y="0px"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="25 25 50 50"
          aria-hidden="true"
          focusable="false"
          role="img"
          aria-label="Loading">
            <path
              d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
              <!-- htmllint tag-name-lowercase="false" -->
              <animateTransform
                attributeName="transform"
                attributeType="XML"
                type="rotate"
                dur="1s"
                from="0 50 50"
                to="360 50 50"
                repeatCount="indefinite">
              </animateTransform>
            </path>
        </svg>
        <span class="visually-hidden">Loading</span>
      </ng-template>

    </form>
  </idt-common-styles-render>
</ng-template>
